import { gql } from "@grandvisionhq/graphql";
import { cartDetails } from "../../../fragments/operations/fragments/cart-details.js";
import { cartFailures, cartValidationErrors } from "../../../fragments/operations/fragments/cart-validation-errors.js";
const GET_CART = gql`
  query GetCart($id: ID!) {
    cart(id: $id) {
      cart {
        ...CartDetailsFragment
      }
      validationErrors {
        ...CartValidationErrorsFragment
      }
      failures {
        ...CartFailuresFragment
      }
    }
  }
  ${cartDetails}
  ${cartFailures}
  ${cartValidationErrors}
`;
export {
  GET_CART
};
//# sourceMappingURL=get-cart.js.map
